export const quickAnswer =
  'An independent fan-made resource for fast answers, practical combat choices and a free build planner.';
export const sourceIds = [];

## Answers First

A code or decision summary comes before the explanation. The site focuses on specific problems rather than reproducing a complete wiki.

## How Facts Are Checked

We consult official developer information and published specialist guides. Source links and verification dates identify the material used. We do not claim first-hand gameplay testing.

## Editorial Recommendations

Ability recommendations are preferences explained through playstyle. They are not official tier lists or measured damage calculations.

## Affiliation and Trademarks

This fan site is not affiliated with Remedy Entertainment or the CONTROL rights holders. Game titles and trademarks belong to their respective owners. Site branding and puzzle diagrams are original fan-site assets.

## Your Planner Data

Choices are stored locally in your browser. Sharing puts the selected ability identifiers into the URL; this is not a connection to your game save.

## Contact and Corrections

Send the page URL, game version, and a description of the issue to [support@controlresonanttools.online](mailto:support@controlresonanttools.online).
